import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class PassEventOverrideIntentComponent extends Component {
  static readonly TYPE_ID: string = '8dfdce19bccf407fb4382cce8d65303f';

  private constructor(
    public readonly solver: string,
  ) {
    super();
  }

  get $typeId(): string {
    return PassEventOverrideIntentComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static create(args: {
    solver: string,
  }): PassEventOverrideIntentComponent {
    return new PassEventOverrideIntentComponent(
        args.solver,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): PassEventOverrideIntentComponent {
    return new PassEventOverrideIntentComponent(
        MapUtils.get<string>(map, 'solver'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'solver': this.solver,
    };
  }

  clone(): this {
    return new PassEventOverrideIntentComponent(
        this.solver,
    ) as this;
  }

  isSame(other: PassEventOverrideIntentComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.solver === this.solver;
  }
}

export class PassEventOverrideIntentComponentBuilder extends DataModelBuilder<PassEventOverrideIntentComponent> {
  build(context: SerializationContext, map: SerializedData): PassEventOverrideIntentComponent {
    return PassEventOverrideIntentComponent.fromMap(context, map);
  }
}
